<template>
	<div class="contact__element contact__radio">
		<h3 v-if="content.title" class="form__subheading radio__heading">{{ radioGroupTitle }}</h3>
		<div v-for="input in content.radioArray" class="radio__element">
			<input type="radio"
						 :id="`contact-${input.en.toLowerCase().replace(' ', '-')}`"
						 :name="`contact-${content.title.en.toLowerCase().replace(' ', '-')}`"
						 :value="`contact-${input.en.toLowerCase().replace(' ', '-')}`"
						 class="radio__input">
			<label :for="`contact-${input.en.toLowerCase().replace(' ', '-')}`"
						 class="radio__label">
				{{ locale === 'en' ? input.en : input.jp }}
			</label>
		</div>
	</div>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from 'vue'
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
	content: Object
})
let radioGroupTitle
if(props.content.title.en) {
	radioGroupTitle = locale.value === 'en' ? props.content.title.en  : props.content.title.jp
}
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.contact__radio {
	.radio__element {
		align-items: center;
		display: flex;
		margin: 1rem 0;
		.radio__input {
			border: 0.05rem solid v.$lightGrey;
			margin: 0 1rem 0 0;
			height: 2rem;
			width: 2rem;
			&:focus {
				background-color: v.$teal;
				border: 0.05rem solid v.$teal;
				box-shadow: 0 0 7px -3px v.$teal;
				outline: none;
				transition: 0.3s;
			}
			&:checked {
				background-color: v.$teal;
			}
		}
	}

}
</style>
